import { Component, OnInit } from '@angular/core';
import {RootScopeService} from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';

import * as $ from 'jquery';

declare global {
  interface Window { ATL_JQ_PAGE_PROPS: any;ze:any;}
}

window.ATL_JQ_PAGE_PROPS = window.ATL_JQ_PAGE_PROPS || {};
window.ze = window.ze || {};

@Component({
  selector: 'app-jira-issue-collector',
  templateUrl: './jira-issue-collector.component.html',
  styleUrls: ['./jira-issue-collector.component.css']
})
export class JiraIssueCollectorComponent implements OnInit {
  jiraIssueCollector: string;
  rootScopeData: RootScopeDeclare;

  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  ngOnInit() {
    // tslint:disable-next-line: max-line-length
    this.jiraIssueCollector = 'https://lfagile.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/md6f5v/b/27/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=ad209f93';
    $.ajax({
      url: this.jiraIssueCollector,
      type: 'get',
      cache: true,
      dataType: 'script',
      success: function() {
        window.ATL_JQ_PAGE_PROPS = $.extend(window.ATL_JQ_PAGE_PROPS, {
        // ==== we add the code below to set the field values ====
          fieldValues: {
            customfield_11517 : window.location.href
          }
        });
      }

    });

      }
}
